// ProudlyCaringSection.js
import React from "react";
import { Phone } from "lucide-react";
import dependableCareImage from "../assets/dependable-care-image.jpg";

const ProudlyCaringSection = () => {
  return (
    <section className="relative bg-white overflow-hidden">
      {/* Top curved section with gradient */}
      <div
        className="relative"
        style={{
          background: "linear-gradient(90deg, #AD2647 0%, #E85D2C 100%)",
          clipPath: "ellipse(150% 100% at 50% 0%)",
          paddingBottom: "120px",
        }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-16 pb-8">
          <div className="max-w-3xl">
            <p className="text-white text-sm font-light tracking-wider mb-3 uppercase">
              ALLAWAH HOME CARE
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              Proudly Caring for Coolamon's Seniors — One Home at a Time
            </h2>
            <p className="text-white text-sm md:text-base font-light leading-relaxed">
              At Allawah Compassionate Home Care, we believe every senior
              deserves to feel valued, respected, and supported in the place
              they call home. Our caregivers provide personalised care that
              promotes safety, independence, and companionship—helping families
              across Coolamon and beyond find peace of mind and loved ones live
              life to the fullest.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom section with image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={dependableCareImage}
              alt="Caregiver with elderly man"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Dependable Care Personalized For Your Needs
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                Care and safety is always the number one priority for your loved
                one. Nursing homes and care facilities may not always be an
                option, and we understand that. Our caregivers are here to help
                you take the next step in and take the burden of caregiving so
                you can simply be family, let our Allawah Lodge caregivers help.
                They are trained and experienced professionals, ensuring the
                care you and your loved one need. Our caregivers are dedicated
                to creating a home environment that is safe and comfortable.
              </p>

              <p>
                Contact us today, and we will start creating your customised
                care plan. Allawah Lodge is here to serve all of your
                non-medical, in-home senior care needs.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProudlyCaringSection;
